import { RouteObject } from 'react-router';
import { ProfilesPage } from './components/ProfilesPage';
import { Outlet } from 'react-router';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { ProfileDetails } from './components/ProfileDetails';
import { Permission } from '@/utils/roles';
export const profileRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute requiredPermissions={[Permission.VIEW_PROFILES]}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <ProfilesPage /> },
      { path: ':profileId', element: <ProfileDetails /> },
    ],
  },
];
